import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Soap = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M13.12 4.733 5.822 12.18c-.275.282-.542.84-.595 1.225l-.33 2.776c-.115 1.003.632 1.688 1.663 1.517l2.862-.471c.4-.069.96-.352 1.236-.643l7.298-7.446c1.262-1.286 1.83-2.751-.134-4.542-1.955-1.774-3.44-1.148-4.702.137'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.902 5.976c.382 2.365 2.374 4.173 4.845 4.413'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4 20.5h16'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M19.385 20.5H4.615A.63.63 0 0 1 4 19.862c0-.348.279-.637.615-.637h14.77c.336 0 .615.289.615.637a.63.63 0 0 1-.615.638'
          fill='currentColor'
        />
        <path
          d='M17.76 4.753c-1.592-1.65-3.151-1.692-4.784 0l-.993 1.029c-.082.085-.115.221-.082.34.624 2.253 2.363 4.056 4.538 4.702a.32.32 0 0 0 .336-.085l.985-1.029c.812-.833 1.206-1.64 1.206-2.457.008-.842-.386-1.658-1.206-2.5'
          fill='currentColor'
        />
        <path
          d='M14.962 11.597a9 9 0 0 1-.69-.374q-.268-.166-.524-.357a5 5 0 0 1-.46-.365 1 1 0 0 1-.14-.128 7 7 0 0 1-.844-.884c-.025-.017-.066-.077-.124-.153-.082-.102-.221-.272-.344-.468a5 5 0 0 1-.32-.502c-.131-.23-.246-.459-.361-.697l-.05-.114c-.12-.28-.485-.36-.696-.141l-4.694 4.864c-.107.11-.205.323-.23.467l-.443 3.257c-.082.578.074 1.122.418 1.488.296.297.706.459 1.15.459q.147 0 .295-.026l3.15-.459a.9.9 0 0 0 .452-.238l4.717-4.888a.432.432 0 0 0-.146-.689z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
